var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinoculars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.347 16.2668V6.41979C9.347 5.08779 8.268 4.00879 6.936 4.00879V4.00879C5.837 4.00879 4.878 4.75179 4.602 5.81479L2.112 15.4248",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27191 13.7279C9.7067 15.1627 9.7067 17.489 8.27191 18.9238C6.83712 20.3586 4.51088 20.3586 3.07609 18.9238C1.6413 17.489 1.6413 15.1627 3.07609 13.7279C4.51088 12.2932 6.83712 12.2932 8.27191 13.7279",
    stroke: "#323232",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.653 16.2668V6.41979C14.653 5.08779 15.732 4.00879 17.064 4.00879V4.00879C18.163 4.00879 19.122 4.75179 19.398 5.81479L21.888 15.4248",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.653 9.9998C14.653 8.5318 13.465 7.3418 12 7.3418C10.535 7.3418 9.347 8.5318 9.347 9.9998",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.347 15.9998C9.347 14.5318 10.535 13.3418 12 13.3418C13.465 13.3418 14.653 14.5318 14.653 15.9998",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9239 13.7279C22.3587 15.1627 22.3587 17.489 20.9239 18.9238C19.4891 20.3586 17.1629 20.3586 15.7281 18.9238C14.2933 17.489 14.2933 15.1627 15.7281 13.7279C17.1629 12.2932 19.4891 12.2932 20.9239 13.7279",
    stroke: "#323232",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default __webpack_public_path__ + "static/media/binoculars.1e0886d97e11c28fc5683acdf3bfa890.svg";
export { ForwardRef as ReactComponent };